import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=5b1d8cbe"
var script = {}
import style0 from "./Mobile.vue?vue&type=style&index=0&id=5b1d8cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports